import { useMemo } from 'react';

/** 用于前端下载的维度列：列 code + 传给 getFilterItemText 的维度类型 */
export interface IDimColumnForDownload {
  code: string;
  convertType: string;
}

/** 仅根据列配置 features.cell.downloadConvertType 判断是否参与下载时的 code→名称 转换 */
function getDownloadConvertType(column: {
  code?: string;
  features?: { cell?: { downloadConvertType?: string; }; };
}): string | null {
  const t = column?.features?.cell?.downloadConvertType;
  return t && typeof t === 'string' ? t : null;
}

/** 收集列配置里带 features.cell.downloadConvertType 的列（仅此配置参与转换） */
function collectDimColumnsForDownload(columns: any[]): IDimColumnForDownload[] {
  const result: IDimColumnForDownload[] = [];
  const collect = (cols: any[]) => {
    cols?.forEach((c: any) => {
      const convertType = getDownloadConvertType(c);
      const code = c?.code?.trim();
      if (convertType && code) result.push({ code, convertType });
      if (c?.children?.length) collect(c.children);
    });
  };
  collect(columns || []);
  return result;
}

export type TGetFilterItemText = (
  regionDataType: string,
  code: string,
  name: string,
  isDownload?: boolean,
) => string;

/**
 * 前端下载用数据：仅当列配置了 features.cell.downloadConvertType 时，该列下载时走 getFilterItemText 做 code→名称 转换
 * @param dataSource 表格当前数据源
 * @param columns 解析后的列配置（含 children）
 * @param getFilterItemText 从 selectorMap 等取名称的方法
 */
export function useDownloadDataSource(
  dataSource: any[],
  columns: any[],
  getFilterItemText: TGetFilterItemText,
): any[] {
  const dimColumns = useMemo(
    () => collectDimColumnsForDownload(columns),
    [columns],
  );

  return useMemo(() => {
    const list = dataSource || [];
    if (dimColumns.length === 0) return list;
    return list.map((row: any) => {
      const r = { ...row };
      dimColumns.forEach(({ code, convertType }) => {
        const val = row[code];
        if (val !== null && val !== undefined && val !== '') {
          r[code] = getFilterItemText(convertType, String(val), String(val), true);
        }
      });
      return r;
    });
  }, [dataSource, dimColumns, getFilterItemText]);
}
